export default __webpack_public_path__ + "static/media/prize-3.21a2d451.webp";